export default class MeigarasearchExtService {
  getMeigaraInfo(meigara, mode, period) {
    return fetch("https://api.tradersr.com/api/meigarasearch_ext?meigara=" + meigara + "&mode=" + mode + "&period=" + period)
      .then(res => res.json());
  }
  getRelations(meigara) {
    return fetch("https://api.tradersr.com/api/meigarasearch_ext?meigara=" + meigara + "&mode=9")
      .then(res => res.json());
  }
}